document.addEventListener('DOMContentLoaded', () => {
  const customInput = document.querySelector('#custom-search-input');
  const searchInput = document.querySelector(
    '.search.search-modal__form input.search__input'
  );
  const searchModalElement = document.querySelector('search-modal');
  const detailsElement = document.querySelector('search-modal details');

  const closeSearchModalDesktop = () => {
    if (searchModalElement) {
      searchModalElement.close();
    } else {
      detailsElement.removeAttribute('open');
      document.body.classList.remove('search-modal--open');
      document.dispatchEvent(new CustomEvent('searchmodal:close'));
    }
  };

  if (customInput && searchInput) {
    customInput.addEventListener('focus', () => {
      if (searchModalElement && !detailsElement.hasAttribute('open')) {
        searchModalElement.open();
      }
      document.body.classList.add('search-input-focused');
      if (detailsElement) {
        detailsElement.classList.remove('hidden');
      }
    });

    document.body.addEventListener('click', (e) => {
      if (window.innerWidth > 990 && detailsElement.hasAttribute('open')) {
        if (e.target.closest('.modal-overlay')) {
          closeSearchModalDesktop();
          return;
        } else if (
          e.target.closest('search-modal') ||
          e.target.closest('.custom-search-input-desktop')
        ) {
          return;
        } else {
          closeSearchModalDesktop();
        }
      }
    });

    customInput.addEventListener('input', () => {
      searchInput.value = customInput.value;
      searchInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    customInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const query = customInput.value.trim();
        if (query) {
          const form = document.querySelector('.search.search-modal__form');
          if (form) {
            searchInput.value = query;
            form.submit();
          }
        }
      }
    });
  }
});

//   Drawer tabs

document.addEventListener('DOMContentLoaded', () => {
  const tabsList = document.querySelectorAll('.menu-drawer__tabs-list-element');
  const contentList = document.querySelectorAll('.menu-drawer__navigation-tab');

  if (tabsList.length <= 0 || contentList.length <= 0) return;

  tabsList.forEach((tab, i) => {
    tab.addEventListener('click', () => {
      contentList.forEach((tab) => {
        tab.classList.remove('active');
      });
      tabsList.forEach((tab) => {
        tab.classList.remove('active');
      });
      tab.classList.add('active');
      contentList[i].classList.add('active');
    });
  });
});